import { render, staticRenderFns } from "./authConfirm.vue?vue&type=template&id=5be90ab0&scoped=true"
import script from "./authConfirm.vue?vue&type=script&lang=js"
export * from "./authConfirm.vue?vue&type=script&lang=js"
import style0 from "./authConfirm.vue?vue&type=style&index=0&id=5be90ab0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be90ab0",
  null
  
)

export default component.exports